import { createContext } from 'react'

export type PagesContextState = {
  canSeePages: boolean
  canEditPages: boolean
  loading: boolean
}

export const PagesContext = createContext<PagesContextState | undefined>(undefined)
